import { createActions } from 'redux-actions';

export const uiActions = createActions({
    SET_UI_STATE:    (path, value) => ({ path, value }),
    UPDATE_UI_STATE: (path, overrides) => ({ path, overrides }),
    REMOVE_UI_STATE: (path) => path,
}, { prefix: 'UI' });
